import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Header, Grid } from 'semantic-ui-react';
import server from '../../functions/server';
import userId from '../../functions/userid';
import $ from 'jquery';

export default class EditGSTIN extends React.Component {
  state = {
    open: false,
    deliveryCharge: ""
  };

  handleClose = () => {
    this.props.handleState({editdeliveryCharge: false});
  };

  handleUpdate = () => {
    let deliveryCharge = this.state.deliveryCharge.trim();
    let deliveryMaximumAmount = this.state.deliveryMaximumAmount.trim();
    let data = {
      id: this.props.id,
      owner: userId(),
      type1: 'delivery_charge',
      type2: 'delivery_maximum_amount',
      value1: deliveryCharge,
      value2: deliveryMaximumAmount,
    }
    console.log(data);
    let context = this;
    $.ajax({
      type: 'POST',
      url: server() + "/shop/updates.php",
      data: data,
      beforeSend: function(x) {
          context.setState({
            dimmer: true,
            loadText: "Updating GSTIN"
          });
      },
      success: function(data, status) {
        console.log(data);
        let editdeliveryCharge = true;
        if (data == "1") {
          context.props.updateProps('delivery_charge', deliveryCharge);
          context.props.updateProps('delivery_maximum_amount', deliveryMaximumAmount);
          editdeliveryCharge = false;
        }
        context.props.handleState({
          dimmer: false,
          loadText: "", editdeliveryCharge
        });
      },
      error: function(data, status) {
        context.props.handleState({
          dimmer: false,
          loadText: "",
          message: data
        });
      }
    });
  }

  render() {
    if (!this.state.deliveryCharge) {
      let deliveryCharge = this.props.deliveryCharge;
      if (!deliveryCharge) {
        deliveryCharge = " ";
      }
      this.setState({deliveryCharge});
    }
    if (!this.state.deliveryMaximumAmount) {
      let deliveryMaximumAmount = this.props.deliveryMaximumAmount;
      if (!deliveryMaximumAmount) {
        deliveryMaximumAmount = " ";
      }
      this.setState({deliveryMaximumAmount});
    }
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Update Delivery Charge & Below Amount</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={7}>
                Delivery Charge<br/>
                <TextField
                  autoFocus
                  margin="dense"
                  id="descriptionText"
                  value={this.state.deliveryCharge}
                  onChange={(e) => {this.setState({deliveryCharge: e.target.value, message:""})}}
                  fullWidth
                />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={2}>
                <br/>
                {'|'}
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={7}>
                Below Amount<br/>
                <TextField
                  autoFocus
                  margin="dense"
                  id="descriptionText"
                  value={this.state.deliveryMaximumAmount}
                  onChange={(e) => {this.setState({deliveryMaximumAmount: e.target.value, message:""})}}
                  fullWidth
                />
              </Grid.Column>
            </Grid>
            <Header as='h4' color='red'>
              {this.state.message}
            </Header>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleUpdate} color="primary">
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
